<template>
    <div class="vm-plan-sale-preview relative" :class="[browser_size]">
        <div class="flex-box flex-a-center flex-bet">
             <div class="flex-box flex-a-center mr24">
                <span class="green fs14 pointer" v-if="plan.status == plan_status.normal" @click="jump">{{$t('c.PlanSalePreview.text1')}}</span>
                <span class="black-8 fs14" v-if="plan.status == plan_status.hide">{{$t('c.PlanSalePreview.text2')}}</span>
            </div>
            <div class="flex-box flex-a-center">
                <span class="mr16 fs12 black-2 gl-hover-text" @click="jump">{{$t('c.PlanSalePreview.text3')}}</span>
                <span class="mr16 fs12 black-2 gl-hover-text" @click="copy">{{$t('c.PlanSalePreview.text4')}}</span>
                <tag class="gray2 fs14 pl20 pr20 pt4 pb4 pointer" @click.native="edit">{{$t('c.PlanSalePreview.text5')}}</tag>
            </div>
        </div>
        <div class="line mt16"></div>
        <div class="flex-box mt8">
            <div class="cover-box mr8" v-if="plan.pic || (plan.sku && plan.sku[0] && plan.sku[0].pic)" @click="jump">
                <pic class="cover" width="64" height="64" :src="plan.pic || (plan.sku && plan.sku[0].pic)"/>
            </div>
            <div class="">
                <div class="black-8 fwb fs14 text-overflow-1 break-all" @click="jump">{{plan.name}}</div>
                <div v-if="plan.product_type == 2" class="fs12 black-5 mt8 lh1">{{$t('c.PlanSalePreview.text6')}} · {{$t('c.PlanSalePreview.text7')}} {{plan.bundle_sku_count || (plan.sku && plan.sku.length)}} {{$t('c.PlanSalePreview.text9')}}</div>
                <div v-if="plan.product_type == 3" class="fs12 black-5 mt8 lh1">{{$t('c.PlanSalePreview.text6')}} · {{$t('c.PlanSalePreview.text8')}} {{plan.bundle_sku_select_count}} {{$t('c.PlanSalePreview.text9')}}</div>
                <div class="mt8 black-8 fwb fs14 lh1">¥ {{plan.show_price}}</div>
            </div>
        </div>
        <div class="flex-box mt8">
            <div class="info-item lh1 mr16">
                <div class="fs12 black-3">{{$t('c.PlanSalePreview.text10')}}</div>
                <div class="mt4 fs12 black-8 fwb">¥{{plan.total_amount}}</div>
            </div>
            <!-- <div class="info-item lh1 mr16">
                <div class="fs12 black-3">浏览</div>
                <div class="mt4 fs12 black-8 fwb">¥515.00</div>
            </div> -->
            <div class="info-item lh1 mr16">
                <div class="fs12 black-3">{{$t('c.PlanSalePreview.text11')}}</div>
                <div class="mt4 fs12 black-8 fwb">{{plan.sponsor_count}}</div>
            </div>
            <div class="info-item lh1">
                <div class="fs12 black-3">{{$t('c.PlanSalePreview.text12')}}</div>
                <div v-if="plan.product_type == 1" class="mt4 fs12 fwb" :class=" plan_stock >= 0 ? 'forever' : 'black-8'">{{plan_stock}}</div>
                <div v-if="plan.product_type == 2 || plan.product_type == 3" class="mt4 fs12 fwb" :class="plan.bundle_stock === '' ?  'black-8':'forever'">{{plan.bundle_stock === '' ? '无限' : plan.bundle_stock }}</div>
            </div>
        </div>
        <template v-if="plan.sku && plan.sku.length > 1">
            <div class="line mt8"></div>
            <template v-for="(item, i) in plan.sku">
                <div v-if="i < limit" class="sku-item flex-box mt8" :key="i">
                    <div v-if="item.pic" class="sku-cover mr12">
                        <pic width="32" height="32" v-if="item.pic" :src="item.pic"/>
                    </div>
                    <div class="black-3 fs12 flex-item-1 text-overflow-2 mr16">{{item.name}}</div>
                    <div class="sec-box mr24">
                        <div class="fs12 black-3">{{$t('c.PlanSalePreview.text13')}}</div>
                        <div class="fs12 black-8 lh1 mt4">{{item.sponsor_count || 0}}</div>
                    </div>
                    <div class="sec-box">
                        <div class="fs12 black-3">{{$t('c.PlanSalePreview.text14')}}</div>
                        <div class="fs12 lh1 mt4" :class=" item.stock == '' ? 'black-8' : 'forever'">{{item.stock === '' ? $t('c.PlanSalePreview.text17') : item.stock}}</div>
                    </div>
                </div>
            </template>
            <div class="flex-box flex-direction-row-reverse pointer" @click="show" v-if="plan.sku.length > 3 && limit == 3">
                <div class="flex-box purple flex-a-center mt16">
                    <span class="fs12">{{$t('c.PlanSalePreview.text15')}}</span>
                    <i class="afd afd-arrow-down ml4 fs12"></i>
                </div>
            </div>
            <div class="flex-box flex-direction-row-reverse pointer" @click="pack" v-if="plan.sku.length > 3 && limit == 1000">
                <div class="flex-box purple flex-a-center mt16">
                    <span class="fs12">{{$t('c.PlanSalePreview.text16')}}</span>
                    <i class="afd afd-arrow-up ml4 fs12"></i>
                </div>
            </div>
        </template>
        <!-- <pic v-if="cover || plan.pic" class="cover" width="120" height="120" :src="cover || plan.pic"/>
        <div class="m16">
            <div v-if="name || plan.name" class="lh1 black-8 fs13 mb16">{{name || plan.name}}</div>
            <div class="flex-box flex-align-items-baseline lh1 price-box">
              <span v-if="sku_count > 0" class="t2">{{sku_count}} 份</span>
              <template v-else>
                <span class="fs28 t1">¥ {{plan.price}}</span>
                <span class="fs14 black-8 ml8 t2">/份</span>
              </template>
            </div>
            <div class="fs14 black-3 mt16" v-if="plan.sponsor_count > 0">{{plan.sponsor_count}} 人发电</div>
        </div>
        <slot></slot> -->
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    plan: {
      default() {
        return {};
      }
    },
  },
  computed: {
    ...mapState("app", ["plan_status", "browser_size"]),
    plan_stock(){
        let re = 0
        let sku = this.plan.sku;
        if(sku){
            if(sku.length == 1){
                re = sku[0].stock === '' ? this.$t('c.PlanSalePreview.text17') :  sku[0].stock;
            }
            else if(sku && sku.findIndex(v => v.stock == '') != -1){
                re = '-'
            }else{
                sku.forEach(v => {
                    re += v.stock
                });
            }
        }

        return re
    }
  },
  data() {
    return {
        limit:3
      //   n: this.browser_size == "small" ? 2 : 3
    };
  },
  mounted() {},
  methods: {
      show(){
         this.limit = 1000;
      },
      pack(){
         this.limit = 3;
      },
      copy() {
        let url = `${location.origin}/item/${this.plan.plan_id}`;
        if(this.$is_bundle_plan(this.plan)){
          url = `${location.origin}/bundle/${this.plan.plan_id}`
        }
        this.mixin_copy(url,{text:'已复制商品链接'}, () => {
            this.$emit("close");
        });
      },
      jump(){
        this.$mixin_router_push(`/item/${this.plan.plan_id}`, true)
      },
      edit(){
        let product_type = this.plan.product_type;
        if(product_type == 2 || product_type == 3){
          this.$mixin_router_push(`/edit/shop?plan_id=${this.plan.plan_id}&product_type=${product_type}&type=bundle`)
          return false;
        }
        this.$mixin_router_push(`/edit/shop?plan_id=${this.plan.plan_id}`)
      }
  }
};
</script>

<style lang="stylus" scoped>
.vm-plan-sale-preview {
    background:$white;
    padding:16px;
    border-radius: 4px;
    .icon-box{
        width 24px;
        height 24px;
        background:$white-bg;
    }
    .vm-tag{
        border-radius:20px;
    }
    .line{
        background:$white-bg;
    }
    .info-item{
        min-width:56px;
    }
    .sku-item{
        .sku-cover{
            width 32px;
            height 32px;
            img{
                border-radius: 1px;
            }
        }
        .sec-box{
            width 80px;
        }
    }
    .cover-box{
        width 64px;
        height 64px;
        // border-radius: 2px;
        img{
            border-radius: 2px;
        }
    }
    &.small {
        // padding: 0 16px;
        .sku-item{
            .sec-box{
                width 56px;
            }
        }
    }
}
</style>
